import InvoiceDetail from './InvoiceDetail';

export default InvoiceDetail;


// WEBPACK FOOTER //
// ./src/scenes/Invoice/InvoiceDetail/index.tsx